import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import PlatformAdminSidebar from './PlatformAdminSidebar';
import Topbar from './Topbar';
import { useState, useEffect } from 'react';
import { useCompany } from '@/hooks/useCompany';

const MainLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { isPlatformAdminView } = useCompany();

  // Listen for changes in localStorage to sync sidebar state across components
  useEffect(() => {
    const handleStorageChange = () => {
      const isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
      setSidebarCollapsed(isCollapsed);
    };

    // Check initial state
    handleStorageChange();

    // Set up event listener
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Platform Admin View gets a stripped-down layout with no topbar
  if (isPlatformAdminView) {
    return (
      <div className="flex h-screen bg-background">
        <PlatformAdminSidebar />
        <main className="relative flex-1 min-w-0 min-h-0 p-6 ml-64 overflow-auto">
          <Outlet context={{ sidebarCollapsed: false }} />
        </main>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-background">
      <Sidebar />
      <div className={`flex-1 min-w-0 flex flex-col transition-all ${sidebarCollapsed ? 'ml-16' : 'ml-64'}`}>
        <Topbar />
        {/* Add padding-top to accommodate the fixed topbar */}
        <main className="relative flex-1 min-h-0 p-6 pt-20 overflow-auto">
          <Outlet context={{ sidebarCollapsed }} />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
